exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboardAER-ae219{margin-bottom:40px;padding:16px 24px;background-color:#fff}.dashboardAER-ae219 .container-c9ce4{display:flex;justify-content:space-between}.dashboardAER-ae219 .container-c9ce4>div{width:48%}", ""]);

// Exports
exports.locals = {
	"dashboardAER": "dashboardAER-ae219",
	"container": "container-c9ce4"
};